class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.mainDetailsToggle.querySelector("summary");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener(
      "toggle",
      this.onToggle.bind(this)
    );

    this.syncAriaExpanded();
  }

  onToggle() {
    this.syncAriaExpanded();
  }

  syncAriaExpanded() {
    const isOpen = this.mainDetailsToggle.hasAttribute("open");
    if (this.summary) {
      this.summary.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class MegaMenuItem extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector(".mega-menu-parent");
    this.container = this.querySelector(".mega-menu-item-container");
    this.items = this.querySelectorAll(".mega-menu-sub a");
    this._isOpen = false;

    if (this.trigger) {
      this.trigger.setAttribute("aria-haspopup", "menu");
      this.trigger.setAttribute("aria-expanded", "false");
    }
    if (this.container) {
      this.container.setAttribute("inert", "");
    }

    this.items.forEach(function (item) {
      item.setAttribute("tabindex", "-1");
    });

    this.items.forEach(function (item) {
      item.addEventListener("mouseover", this.mouseOver.bind(this));
    }.bind(this));

    this.rightItems = this.querySelectorAll(
      ".mega-menu-right .mega-menu-grandchilds:first-child"
    );
    this.rightItems.forEach(function (item) {
      item.classList.add("active");
    });

    this.addEventListener("keydown", this.onKeyDown.bind(this));
    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
  }

  getMenuItems() {
    if (!this.container) return [];
    return Array.from(this.container.querySelectorAll('[role="menuitem"]'));
  }

  getSiblingTriggers() {
    var nav = this.closest(".header__inline-menu");
    if (!nav) return [];
    return Array.from(nav.querySelectorAll(".mega-menu-parent"));
  }

  focusSiblingTrigger(direction) {
    var triggers = this.getSiblingTriggers();
    var idx = triggers.indexOf(this.trigger);
    if (idx === -1) return;
    this.close();
    var next =
      direction === "next"
        ? triggers[(idx + 1) % triggers.length]
        : triggers[(idx - 1 + triggers.length) % triggers.length];
    if (next) next.focus();
  }

  open() {
    if (this._isOpen) return;
    this._isOpen = true;
    if (this.container) this.container.removeAttribute("inert");
    if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
  }

  close() {
    if (!this._isOpen) return;
    this._isOpen = false;
    if (this.container) this.container.setAttribute("inert", "");
    if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
  }

  openAndFocusFirst() {
    this.open();
    var self = this;
    requestAnimationFrame(function () {
      var items = self.getMenuItems();
      if (items.length) items[0].focus();
    });
  }

  openAndFocusLast() {
    this.open();
    var self = this;
    requestAnimationFrame(function () {
      var items = self.getMenuItems();
      if (items.length) items[items.length - 1].focus();
    });
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    var self = this;
    setTimeout(function () {
      if (!self.contains(document.activeElement)) self.close();
    });
  }

  onFocusOut() {
    var self = this;
    setTimeout(function () {
      if (!self.contains(document.activeElement)) self.close();
    });
  }

  onKeyDown(event) {
    var onTrigger = document.activeElement === this.trigger;
    var items = this.getMenuItems();
    var idx = items.indexOf(document.activeElement);
    var inPanel = idx !== -1;

    switch (event.code) {
      case "Enter":
      case "Space":
        if (onTrigger) {
          event.preventDefault();
          if (this._isOpen) {
            this.close();
          } else {
            this.openAndFocusFirst();
          }
        }
        break;

      case "ArrowDown":
        event.preventDefault();
        if (onTrigger) {
          this.openAndFocusFirst();
        } else if (inPanel) {
          items[(idx + 1) % items.length].focus();
        }
        break;

      case "ArrowUp":
        event.preventDefault();
        if (onTrigger) {
          this.openAndFocusLast();
        } else if (inPanel) {
          items[(idx - 1 + items.length) % items.length].focus();
        }
        break;

      case "ArrowRight":
        event.preventDefault();
        this.focusSiblingTrigger("next");
        break;

      case "ArrowLeft":
        event.preventDefault();
        this.focusSiblingTrigger("prev");
        break;

      case "Escape":
        if (this._isOpen) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          if (this.trigger) this.trigger.focus();
        }
        break;

      case "Home":
        if (inPanel && items.length) {
          event.preventDefault();
          items[0].focus();
        }
        break;

      case "End":
        if (inPanel && items.length) {
          event.preventDefault();
          items[items.length - 1].focus();
        }
        break;
    }
  }

  mouseOver(event) {
    var grandchilds = event.currentTarget
      .closest(".mega-menu-item-container")
      .querySelectorAll(".mega-menu-grandchilds");

    grandchilds.forEach(function (item) {
      if (
        item.dataset.megaSubHandle == event.currentTarget.dataset.megaHandle
      ) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }
}

customElements.define("mega-menu-item", MegaMenuItem);
